import { LegendWithCheckboxAndFaviconAndIcon } from "@similarweb/ui-components";

export const RegionalsLegendsWithFaviconAndCheckbox = (props) => (
    <LegendWithCheckboxAndFaviconAndIcon
        {...props}
        iconName="regionals-world"
    />
);
